import {MarketData} from 'etc/types';

export const MARKET_DATA: MarketData = {
  ad: {
    locale: 'es-ES',
    country: 'Andorra',
    sfMarket: 'Andorra (es)',
  },
  'ae-ar': {
    locale: 'ar',
    country: 'UAE',
  },
  'ae-en': {
    locale: 'en-US',
    country: 'UAE',
  },
  ar: {
    locale: 'es-LA',
    country: 'Argentina',
    sfMarket: 'Argentina (es_MX)',
  },
  at: {
    locale: 'de-DE',
    country: 'Austria',
    sfMarket: 'Austria (de)',
  },
  au: {
    locale: 'en-US',
    country: 'Australia',
    sfMarket: 'Australia (en_US)',
  },
  'be-fr': {
    locale: 'fr-FR',
    country: 'Belgium',
    sfMarket: 'Belgium (fr)',
  },
  'be-nl': {
    locale: 'nl-NL',
    country: 'Belgium',
    sfMarket: 'Belgium (nl_NL)',
  },
  bg: {
    locale: 'en-US',
    country: 'Bulgaria',
    sfMarket: 'Bulgaria (en_US)',
  },
  'bh-ar': {
    locale: 'ar',
    country: 'Bahrain',
  },
  'bh-en': {
    locale: 'en-US',
    country: 'Bahrain',
  },
  bo: {
    locale: 'es-LA',
    country: 'Bolivia',
    sfMarket: 'Bolivia (es_MX)',
  },
  br: {
    locale: 'pt-BR',
    country: 'Brazil',
    sfMarket: 'Brazil (pt_BR)',
  },
  'ca-en': {
    locale: 'en-US',
    country: 'Canada',
    sfMarket: 'Canada (en_US)',
  },
  'ca-fr': {
    locale: 'fr-CA',
    country: 'Canada',
    sfMarket: 'Canada (fr_CA)',
  },
  'ch-de': {
    locale: 'de-DE',
    country: 'Switzerland',
    sfMarket: 'Switzerland (de)',
  },
  'ch-fr': {
    locale: 'fr-FR',
    country: 'Switzerland',
    sfMarket: 'Switzerland (fr)',
  },
  cl: {
    locale: 'es-LA',
    country: 'Chile',
    sfMarket: 'Chile (es_MX)',
  },
  co: {
    locale: 'es-LA',
    country: 'Colombia',
    sfMarket: 'Colombia (es_MX)',
  },
  cr: {
    locale: 'es-LA',
    country: 'Costa_Rica',
    sfMarket: 'Costa_Rica (es_MX)',
  },
  cy: {
    locale: 'en-US',
    country: 'Cyprus',
    sfMarket: 'Cyprus (en_US)',
  },
  cz: {
    locale: 'en-US',
    country: 'Czech_Republic',
    sfMarket: 'Czech_Republic (en_US)',
  },
  de: {
    locale: 'de-DE',
    country: 'Germany',
    sfMarket: 'Germany (de)',
  },
  do: {
    locale: 'es-LA',
    country: 'Dominican_Republic',
    sfMarket: 'Dominican_Republic (es_MX)',
  },
  dk: {
    locale: 'en-US',
    country: 'Denmark',
    sfMarket: 'Denmark (en_US)',
  },
  'dz-ar': {
    locale: 'ar',
    country: 'Algeria',
  },
  'dz-fr': {
    locale: 'fr-FR',
    country: 'Algeria',
  },
  ec: {
    locale: 'es-LA',
    country: 'Ecuador',
    sfMarket: 'Ecuador (es_MX)',
  },
  ee: {
    locale: 'en-US',
    country: 'Estonia',
    sfMarket: 'Estonia (en_US)',
  },
  es: {
    locale: 'es-ES',
    country: 'Spain',
    sfMarket: 'Spain (es)',
  },
  'eg-ar': {
    locale: 'ar',
    country: 'Egypt',
  },
  'eg-en': {
    locale: 'en-US',
    country: 'Egypt',
  },
  fi: {
    locale: 'fi-FI',
    country: 'Finland',
    sfMarket: 'Finland (fi)',
  },
  fr: {
    locale: 'fr-FR',
    country: 'France',
    sfMarket: 'France (fr)',
  },
  gr: {
    locale: 'en-US',
    country: 'Greece',
    sfMarket: 'Greece (en_US)',
  },
  gt: {
    locale: 'es-LA',
    country: 'Guatemala',
    sfMarket: 'Guatemala (es_MX)',
  },
  'hk-en': {
    locale: 'en-US',
    country: 'Hong_Kong',
    sfMarket: 'Hong_Kong (en_US)',
  },
  'hk-zh': {
    locale: 'zh-TW',
    country: 'Hong_Kong',
    sfMarket: 'Hong_Kong (zh_TW)',
  },
  hn: {
    locale: 'es-LA',
    country: 'Honduras',
    sfMarket: 'Honduras (es_MX)',
  },
  hu: {
    locale: 'hu-HU',
    country: 'Hungary',
    sfMarket: 'Hungary (hu)',
  },
  ie: {
    locale: 'en-US',
    country: 'Ireland',
    sfMarket: 'Ireland (en_US)',
  },
  id: {
    locale: 'id-ID',
    country: 'Indonesia',
    sfMarket: 'Indonesia (id)',
  },
  in: {
    locale: 'en-US',
    country: 'India',
    sfMarket: 'India (en_US)',
    phonePrefix: '+91',
  },
  is: {
    locale: 'en-US',
    country: 'Iceland',
    sfMarket: 'Iceland (en_US)',
  },
  'il-en': {
    locale: 'en-US',
    country: 'Israel',
  },
  'il-he': {
    locale: 'he-IL',
    country: 'Israel',
  },
  it: {
    locale: 'it-IT',
    country: 'Italy',
    sfMarket: 'Italy (it)',
  },
  'jo-ar': {
    locale: 'ar',
    country: 'Jordan',
  },
  'jo-en': {
    locale: 'en-US',
    country: 'Jordan',
  },
  jp: {
    locale: 'ja-JP',
    country: 'Japan',
    sfMarket: 'Japan (ja)',
  },
  'kw-ar': {
    locale: 'ar',
    country: 'Kuwait',
  },
  'kw-en': {
    locale: 'en-US',
    country: 'Kuwait',
  },
  'lb-ar': {
    locale: 'ar',
    country: 'Lebanon',
  },
  'lb-en': {
    locale: 'en-US',
    country: 'Lebanon',
  },
  li: {
    locale: 'de-DE',
    country: 'Liechtenstein',
    sfMarket: 'Liechtenstein (de)',
  },
  lt: {
    locale: 'en-US',
    country: 'Lithuania',
    sfMarket: 'Lithuania (en_US)',
  },
  'lu-de': {
    locale: 'de-DE',
    country: 'Luxembourg',
    sfMarket: 'Luxembourg (de)',
  },
  'lu-fr': {
    locale: 'fr-FR',
    country: 'Luxembourg',
    sfMarket: 'Luxembourg (fr)',
  },
  lv: {
    locale: 'en-US',
    country: 'Latvia',
    sfMarket: 'Latvia (en_US)',
  },
  'ma-ar': {
    locale: 'ar',
    country: 'Morocco',
  },
  'ma-fr': {
    locale: 'fr-FR',
    country: 'Morocco',
  },
  mc: {
    locale: 'fr-FR',
    country: 'Monaco',
    sfMarket: 'Monaco (fr)',
  },
  mx: {
    locale: 'es-LA',
    country: 'Mexico',
    sfMarket: 'Mexico (es_MX)',
  },
  mt: {
    locale: 'en-US',
    country: 'Malta',
    sfMarket: 'Malta (en_US)',
  },
  'my-en': {
    locale: 'en-US',
    country: 'Malaysia',
    sfMarket: 'Malaysia (en_US)',
  },
  ni: {
    locale: 'es-LA',
    country: 'Nicaragua',
    sfMarket: 'Nicaragua (es_MX)',
  },
  nl: {
    locale: 'nl-NL',
    country: 'Netherlands',
    sfMarket: 'Netherlands (nl_NL)',
  },
  no: {
    locale: 'en-US',
    country: 'Norway',
    sfMarket: 'Norway (en_US)',
  },
  nz: {
    locale: 'en-US',
    country: 'New_Zealand',
    sfMarket: 'New_Zealand (en_US)',
  },
  'om-ar': {
    locale: 'ar',
    country: 'Oman',
  },
  'om-en': {
    locale: 'en-US',
    country: 'Oman',
  },
  pa: {
    locale: 'es-LA',
    country: 'Panama',
    sfMarket: 'Panama (es_MX)',
  },
  py: {
    locale: 'es-LA',
    country: 'Paraguay',
    sfMarket: 'Paraguay (es_MX)',
  },
  pe: {
    locale: 'es-LA',
    country: 'Peru',
    sfMarket: 'Peru (es_MX)',
  },
  ph: {
    locale: 'en-US',
    country: 'Philippines',
    sfMarket: 'Philippines (en_US)',
  },
  pl: {
    locale: 'pl-PL',
    country: 'Poland',
    sfMarket: 'Poland (pl)',
  },
  'ps-ar': {
    locale: 'ar',
    country: 'Palestine',
  },
  'ps-en': {
    locale: 'en-US',
    country: 'Palestine',
  },
  pt: {
    locale: 'en-US',
    country: 'Portugal',
    sfMarket: 'Portugal (en_US)',
  },
  'qa-ar': {
    locale: 'ar',
    country: 'Qatar',
  },
  'qa-en': {
    locale: 'en-US',
    country: 'Qatar',
  },
  ro: {
    locale: 'en-US',
    country: 'Romania',
    sfMarket: 'Romania (ro)',
  },
  'sa-ar': {
    locale: 'ar',
    country: 'Saudi_Arabia',
  },
  'sa-en': {
    locale: 'en-US',
    country: 'Saudi_Arabia',
  },
  se: {
    locale: 'sv-SE',
    country: 'Sweden',
    sfMarket: 'Sweden (sv)',
  },
  'sg-en': {
    locale: 'en-US',
    country: 'Singapore',
    sfMarket: 'Singapore (en_US)',
  },
  sk: {
    locale: 'en-US',
    country: 'Slovakia',
    sfMarket: 'Slovakia (en_US)',
  },
  sv: {
    locale: 'es-LA',
    country: 'El_Salvador',
    sfMarket: 'El_Salvador (es_MX)',
  },
  'th-th': {
    locale: 'th-TH',
    country: 'Thailand',
  },
  'th-en': {
    locale: 'en-US',
    country: 'Thailand',
    sfMarket: 'Thailand (th)',
  },
  'tn-ar': {
    locale: 'ar',
    country: 'Tunisia',
  },
  'tn-fr': {
    locale: 'fr-FR',
    country: 'Tunisia',
  },
  tr: {
    locale: 'tr-TR',
    country: 'Turkey',
    sfMarket: 'Turkey (tr)',
  },
  tw: {
    locale: 'zh-TW',
    country: 'Taiwan',
    sfMarket: 'Taiwan (zh_TW)',
  },
  uk: {
    locale: 'en-US',
    country: 'United_Kingdom',
    sfMarket: 'United_Kingdom (en_US)',
  },
  uy: {
    locale: 'es-LA',
    country: 'Uruguay',
    sfMarket: 'Uruguay (es_MX)',
  },
  us: {
    locale: 'en-US',
    country: 'United_States',
    sfMarket: 'United_States (en_US)',
  },
  'vn-vi': {
    locale: 'vi-VN',
    country: 'Vietnam',
    sfMarket: 'Vietnam (vi)',
  },
  'vn-en': {
    locale: 'en-US',
    country: 'Vietnam',
  },
  za: {
    locale: 'en-US',
    country: 'South_Africa',
  },
};
